import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';

import { Observable } from 'rxjs';

import { ClaimsService } from './claims.service';
import { EndpointsService } from './endpoints.service';
import { FilterService } from './filter.service';
import { TokenService } from './token.service';
import { IAccountModel } from '../interfaces';

@Injectable()
export class AuthService {
    constructor(
        private http: Http,
        private claimsService: ClaimsService,
        private endpointsService: EndpointsService,
        private tokenService: TokenService,
        private filterService: FilterService) {
    }

    public login(account: IAccountModel): Observable<Response> {
        let requestBody = 'grant_type=password&username=' + account.username + '&password=' + account.password;

        let requestHeader = new Headers();
        requestHeader.append('Content-Type', 'application/x-www-form-urlencoded');

        return this.http.post(this.endpointsService.ACCOUNT_LOGIN, requestBody, { headers: requestHeader })
            .map((response: Response) => {
                let token = response.json() && response.json().access_token;
                if (token) {
                    this.tokenService.setBearerToken(token);
                    this.tokenService.setRefreshToken(response.json().refresh_token);
                    this.tokenService.setBearerTokenExpiration(response.json()[".expires"]);
                    return true;
                }
                else { return false; }
            })
            .catch((error: any) => Observable.throw(error || 'Server error'));
    }

    public getFilters(): Observable<Response> {
        return this.http.get(this.endpointsService.GET_FILTERS_URL).map((response: Response) => {
            let result = response.json();
            this.filterService.setCountries(result.countries);
            this.filterService.setProviders(result.providers);
            this.filterService.setPublishers(result.publishers);
            this.filterService.setPublisherGroups(result.groups);
            this.filterService.setBrands(result.brands);
            this.filterService.setColors(result.entityColors);
            return true;
        }).catch((error: any) => Observable.throw(error || 'Server error'));
    }

    public sendForgotPassword(email: string): Observable<Response> {
        return this.http.get(this.endpointsService.SEND_FORGOT_PASSWORD_URL + "?email=" + email).map((response: Response) => {
            return response;
        }).catch((error: any) => Observable.throw(error || 'Server error'));
    }

    public sendResetPassword(token: string, newPassword: string): Observable<Response> {
        return this.http.post(this.endpointsService.SEND_RESET_PASSWORD_URL, { token, newPassword })
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error || 'Server error'));
    }

    public getClaims(): Observable<Response> {
        return this.http.get(this.endpointsService.GET_CLAIMS_URL).map((response: Response) => {
            let result = response.json();
            this.claimsService.setUserId(result.userId);
            this.claimsService.setUserTypeId(result.userTypeId);
            this.claimsService.setFirstName(result.firstName);
            this.claimsService.setLastName(result.lastName);
            return true;
        }).catch((error: any) => Observable.throw(error || 'Server error'));
    }

    public isAuthorized(): boolean {
        let token = this.tokenService.getBearerToken();
        let userid = this.claimsService.getUserId();
        return token !== null && token !== '' && userid > 0;
    }

    public isBearerTokenExpired(): boolean {
        return this.tokenService.isBearerTokenExpired();
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/auth.service.ts